import React from 'react';
import { Field } from 'react-final-form';
import { IMaskMixin } from 'react-imask';
import { FormField, FormHelp, Input, Label } from '@zillow/constellation';
import { FieldValidator } from '../../../validation/validation';
import { CURRENT_ZIP } from '../../../constants/formFieldNames';

// The "size" and "as" props that come from the IMaskMixin have type definitions that are
// different than the "size" and "as" props that the Input component accept, so we don't
// want to spread those props into the Input component.
const MaskedZipCodeInput = IMaskMixin<HTMLInputElement>(({ inputRef, size, as, ...props }) => (
  <Input {...props} ref={inputRef} placeholder="XXXXX" />
));

export default function ZipCodeField() {
  return (
    <Field
      name={CURRENT_ZIP}
      render={({ input, meta }) => {
        const { touched, active, error } = meta;
        const isInvalid = touched && !active && Boolean(error);
        const { onChange, ...restInput } = input;

        return (
          <FormField
            error={isInvalid}
            label={<Label>ZIP code</Label>}
            control={
              <MaskedZipCodeInput mask="00000-0000" onAccept={(value: unknown) => onChange(value)} {...restInput} />
            }
            description={isInvalid && <FormHelp>{error}</FormHelp>}
          />
        );
      }}
      validate={(zipCode) => {
        const zipCodeRegex = /^\d{5}(?:[-]\d{4})?$/;
        const errors = new FieldValidator(zipCode)
          .required('Enter a valid ZIP code')
          .regex(zipCodeRegex, 'Enter a valid ZIP code in the format XXXXX or XXXXX-XXXX')
          .build();

        return errors ? errors : null;
      }}
    />
  );
}
